import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import getInputGroupings from '../Scripts/_getInputGroupings';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppConsumer = AppContext.Consumer;  

const CAMPUSES = [ 'Allen' , 'Cypress' , 'Katy' , 'Pearland' , 'Spring/Klein' ];

const PROGRAMS = ['Student ATHlete', 'Next Level ATHlete', 'Rebuild ATHlete', 'Prebuild ATHlete', 'Forever ATHlete'];

const PROGRAM_TIERS = [
  { program: 'Student ATHlete', tiers: ['Gold'] },
  { program: 'Next Level ATHlete', tiers: ['Gold'] },
  { program: 'Rebuild ATHlete', tiers: ['Gold'] },
  { program: 'Prebuild ATHlete', tiers: ['Gold'] },
  { program: 'Forever ATHlete', tiers: ['Gold'] },
];

const PROGRAM_GROUPINGS = [
  { program: 'Student ATHlete', groupings: ['8-12', '12-14', '14-18'] },
  { program: 'Next Level ATHlete', groupings: ['College Prep', 'Professional'] },
  { program: 'Rebuild ATHlete', groupings: ['Ankle Injury', 'Knee Injury', 'Hip Injury', 'Elbow Injury', 'Shoulder Injurys', 'Other : Please specify'] },
  { program: 'Prebuild ATHlete', groupings: ['Activate', 'Renew'] },
  { program: 'Forever ATHlete', groupings: ['Health', 'Training'] },
  { program: 'Team ATHlete', groupings: ['Add Team Name'] },
];

const INPUT_SETTINGS = [
    {tag:'height'             , inputStringName: 'Height [in]'                  , minValue: 36 , maxValue: 84  , precision:1 },
    {tag:'seatedHeight'       , inputStringName: 'Seated Height [in]'           , minValue: 36 , maxValue: 72  , precision:1 },
    {tag:'sitAndReach'        , inputStringName: 'Sit & Reach [in]'             , minValue:  3 , maxValue: 27  , precision:1 },
    {tag:'weight'             , inputStringName: 'Weight [lbs]'                 , minValue: 50 , maxValue: 450 , precision:1 },
    {tag:'bodyFat'            , inputStringName: 'Body Fat [%]'                 , minValue: 5  , maxValue: 50  , precision:1 },
    {tag:'bmi'                , inputStringName: 'BMI [kg/m2]'                  , minValue: 10  , maxValue: 60  , precision:1 },
    {tag:'phv'                , inputStringName: 'PHV [years]'                  , minValue: -10  , maxValue: 10  , precision:1 },
   
    {tag:'aslr_R'             , inputStringName: 'ASLR RT'                      , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'aslr_L'             , inputStringName: 'ASLR LT'                      , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'shoulderMob_R'      , inputStringName: 'Shoulder Mob RT'              , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'shoulderMob_L'      , inputStringName: 'Shoulder Mob LT'              , minValue: 1 , maxValue: 3    ,  precision:0 },

    {tag:'modThomas_psoas_R'  , inputStringName: 'Mod.Thom Pso RT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'modThomas_ITband_R' , inputStringName: 'Mod.Thom ITB RT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'modThomas_quads_R'  , inputStringName: 'Mod.Thom Quad RT'             , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'modThomas_psoas_L'  , inputStringName: 'Mod.Thom Pso LT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'modThomas_ITband_L' , inputStringName: 'Mod.Thom ITB LT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'modThomas_quads_L'  , inputStringName: 'Mod.Thom Quad LT'             , minValue: 0 , maxValue: 1    ,  precision:0 },

    {tag:'yBalance_R'         , inputStringName: 'Y-Balance RT'                 , minValue: 0 , maxValue: 150  ,  precision:1 },
    {tag:'yBalance_shldr_R'   , inputStringName: 'SL Squat Shoulder RT'         , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'yBalance_hip_R'     , inputStringName: 'SL Squat Hip RT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'yBalance_knee_R'    , inputStringName: 'SL Squat Knee RT'             , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'yBalance_L'         , inputStringName: 'Y-Balance LT'                 , minValue: 0 , maxValue: 150  ,  precision:1 },
    {tag:'yBalance_shldr_L'   , inputStringName: 'SL Squat Shoulder LT'         , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'yBalance_hip_L'     , inputStringName: 'SL Squat Hip LT'              , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'yBalance_knee_L'    , inputStringName: 'SL Squat Knee LT'             , minValue: 0 , maxValue: 1    ,  precision:0 },

    {tag:'rotation_hip_R'     , inputStringName: 'Hip IR RT'                    , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'rotation_hip_L'     , inputStringName: 'Hip IR LT'                    , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'dflexion_ankle_R'   , inputStringName: 'Ankle Dors. RT'               , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'dflexion_ankle_L'   , inputStringName: 'Ankle Dors. LT'               , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'rotation_spine'     , inputStringName: 'Spine Rot.'                   , minValue: 0 , maxValue: 1    ,  precision:0 },
    {tag:'extension_spine'    , inputStringName: 'Spine Ext.'                   , minValue: 0 , maxValue: 1    ,  precision:0 },

    {tag:'ohsquat'            , inputStringName: 'Overhead Squat'               , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'hinge'              , inputStringName: 'Hinge'                        , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'squat'              , inputStringName: 'Squat'                        , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'pushup'             , inputStringName: 'Push Up'                      , minValue: 1 , maxValue: 3    ,  precision:0 },
    {tag:'squatJump_FreeArms' , inputStringName: 'Squat Jump [in]'              , minValue: 5 , maxValue: 45   ,  precision:2 },
    {tag:'CMJ_FreeArms'       , inputStringName: 'CM Jump [in]'                 , minValue: 5 , maxValue: 45   ,  precision:2 },
    {tag:'cmj_peak_power_normalized' , inputStringName: 'CMJ Power [W/lb]'       , minValue: 5 , maxValue: 45   ,  precision:2 },
    {tag:'broadJump'          , inputStringName: 'Broad Jump [in]'              , minValue: 10 , maxValue: 126 ,  precision:2 },
    {tag:'RSI'                , inputStringName: 'RSI'                          , minValue: 0.25, maxValue: 4  ,  precision:2 },
    {tag:'ecc_util_jump'      , inputStringName: 'Ecc. Util.'                   , minValue: 0.25, maxValue: 2  ,  precision:2 },

    {tag:'tenYard'            , inputStringName: '10yd time [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'twentyYard'         , inputStringName: '20yd time [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'thirtyYard'         , inputStringName: '30yd time [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'fortyYard'          , inputStringName: '40yd time [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'sprint_speed'       , inputStringName: 'Speed [mph]'                  , minValue: 5 , maxValue: 25  ,  precision:2 },
    {tag:'five05_L'           , inputStringName: '5-0-5 LT [s]'                 , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'five05_R'           , inputStringName: '5-0-5 RT [s]'                 , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'five10five_L'       , inputStringName: '5-10-5 LT [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    {tag:'five10five_R'       , inputStringName: '5-10-5 RT [s]'                , minValue: 1 , maxValue: 8   ,  precision:2 },
    // {tag:'ncmKeiserAirSquat'  , inputStringName: 'NCM Keiser Air Squat'         , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'squatType'          , inputStringName: 'Squat Type'                   , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'squatWeight'        , inputStringName: 'Squat Weight'                 , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'deadLift'           , inputStringName: 'Deadlift'                     , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'deadLiftWeight'     , inputStringName: 'Deadlift Weight'              , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'benchPressWeight'   , inputStringName: 'Bench Press Weight'           , minValue: 0 , maxValue: 100 , precision:2 },
    // {tag:'chinUps'            , inputStringName: 'Chin Ups'                     , minValue: 0 , maxValue: 100 , precision:2 },
    {tag:'IMTP_PF'            , inputStringName: 'IMTP Force [N]'                 , minValue: 300 , maxValue: 3500 ,  precision:0 },
    {tag:'IMTP_RFD'           , inputStringName: 'IMTP RFD [N/s]'                 , minValue: 0 , maxValue:   999999999 ,  precision:0 },
    {tag:'IMTP_PF_normalized' , inputStringName: 'Force by BW [N/lb]'             , minValue: 0.5 , maxValue: 30 ,  precision:1 },
    {tag:'IMTP_RFD_normalized', inputStringName: 'RFD by BW [N/s/lb]'             , minValue: 0 , maxValue: 999999999 ,  precision:1 },
    {tag:'five00Rows'         , inputStringName: '500M Row [s]'                   , minValue: 30 , maxValue: 180  ,  precision:1 },
    {tag:'two000Rows'         , inputStringName: '2000M Row [s]'                  , minValue: 0 , maxValue: 500  ,  precision:1 },
    {tag:'groin_squeeze'      , inputStringName: 'Groin Squeeze [N]'              , minValue: 0 , maxValue: 2000 ,  precision:0 },
    {tag:'sixMinWalk'         , inputStringName: '6-minute walk [yards]'          , minValue: 300 , maxValue: 850 ,  precision:1 },
    {tag:'fiveRepSitToStand'  , inputStringName: '5-rep sit-to-stand [s]'         , minValue: 6 , maxValue: 30 ,  precision:1 },
    {tag:'aslrDeg_L'          , inputStringName: 'ASLR LT [deg]'                  , minValue: 0 , maxValue: 180 ,  precision:1 },
    {tag:'aslrDeg_R'          , inputStringName: 'ASLR RT [deg]'                  , minValue: 0 , maxValue: 180 ,  precision:1 },
    {tag:'shoulderIntRot_L'  , inputStringName: 'Shoulder Int. Rot. LT [deg]'    , minValue: 0 , maxValue: 180 ,  precision:1 },
    {tag:'shoulderIntRot_R'  , inputStringName: 'Shoulder Int. Rot. RT [deg]'    , minValue: 0 , maxValue: 180 ,  precision:1 },
];

const BLANKPROP = { value:-99999,isValid:false,optOutReason:'null' }; // repeated below in blankEval_tab1
const BLANKTEXT = { value: ' ', isValid:true,optOutReason:'null' }; // repeated below in blankEval_tab1

const BLANKEVAL = {
  tab_ID: 1, stepInd: 0, sessInd: 0, outcomeInd: 0, tier: 'Gold', measurementDate: new Date(), numEvals: 0, 
  height:                       BLANKPROP, 
  seatedHeight:                 BLANKPROP , 
  sitAndReach:                  BLANKPROP , 
  weight:                       BLANKPROP, 
  bodyFat:                      BLANKPROP, 
  aslr_R:                       BLANKPROP, 
  aslr_L:                       BLANKPROP, 
  shoulderMob_R:                BLANKPROP, 
  shoulderMob_L:                BLANKPROP, 
  modThomas_psoas_R:            BLANKPROP, 
  modThomas_ITband_R:           BLANKPROP, 
  modThomas_quads_R:            BLANKPROP, 
  modThomas_psoas_L:            BLANKPROP, 
  modThomas_ITband_L:           BLANKPROP, 
  modThomas_quads_L:            BLANKPROP, 
  yBalance_R:                   BLANKPROP, 
  yBalance_shldr_R:             BLANKPROP, 
  yBalance_hip_R:               BLANKPROP, 
  yBalance_knee_R:              BLANKPROP, 
  yBalance_L:                   BLANKPROP, 
  yBalance_shldr_L:             BLANKPROP, 
  yBalance_hip_L:               BLANKPROP, 
  yBalance_knee_L:              BLANKPROP,
  rotation_hip_R:               BLANKPROP,
  dflexion_ankle_R:             BLANKPROP,
  rotation_hip_L:               BLANKPROP,
  dflexion_ankle_L:             BLANKPROP,
  rotation_spine:               BLANKPROP,
  extension_spine:              BLANKPROP,
  ohsquat:                      BLANKPROP, 
  hinge:                        BLANKPROP, 
  squat:                        BLANKPROP, 
  pushup:                       BLANKPROP, 
  squatJump_FreeArms:           BLANKPROP,
  CMJ_FreeArms:                 BLANKPROP, 
  broadJump:                    BLANKPROP, 
  RSI:                          BLANKPROP, 
  tenYard:                      BLANKPROP, 
  twentyYard:                   BLANKPROP, 
  thirtyYard:                   BLANKPROP, 
  fortyYard:                    BLANKPROP, 
  five05_L:                     BLANKPROP, 
  five05_R:                     BLANKPROP, 
  five10five_L:                 BLANKPROP, 
  five10five_R:                 BLANKPROP, 
  IMTP_PF:                      BLANKPROP, 
  IMTP_RFD:                     BLANKPROP, 
  two000Rows:                   BLANKPROP,
  five00Rows:                   BLANKPROP,
  groin_squeeze:                BLANKPROP,
  sixMinWalk:                   BLANKPROP,
  fiveRepSitToStand:            BLANKPROP,
  aslrDeg_L:                    BLANKPROP,
  aslrDeg_R:                    BLANKPROP,
  shoulderIntRot_L:             BLANKPROP,
  shoulderIntRot_R:             BLANKPROP,

  notes_anthro:                 BLANKTEXT,
  notes_movement:               BLANKTEXT,
  notes_exercise:               BLANKTEXT,
  notes_flexibility:            BLANKTEXT,
  notes_stability:              BLANKTEXT,
  notes_jumping:                BLANKTEXT,
  notes_springing:              BLANKTEXT,
  notes_strength:               BLANKTEXT,
  notes_cardio:                 BLANKTEXT
};

export const AppProvider = ({ children }) => {

  // main objects
  const [user, setUser]       = useState(null);
  const [view, setView]       = useState('login');
  const [norms, setNorms]     = useState(null);
  const [athlete, setAthlete] = useState(null);
  const [session, setSession] = useState(null);

  // filtering etc
  const [currentCampus, setCurrentCampus]       = useState('');
  const [currentProgram, setCurrentProgram]     = useState('All');
  const [currentGender, setCurrentGender]       = useState('All');
  const [currentEvalCount, setCurrentEvalCount] = useState('Any');
  const [currentDataType, setCurrentDataType]   = useState('Any');

  // dropdowns etc
  const [coachObjectList, setCoachObjectList] = useState({});
  const [athleteNamesList, setAthleteNamesList] = useState([]);
  const [campusList, setCampusList] = useState([]); // options depending on user role
  
  // eval capture, edit and report generation
  const [startDate, setStartDate] = useState(new Date());
  const [currentAthleteEvaluations, setCurrentAthleteEvaluations] = useState([]);
  const [currentAthleteSessionList, setCurrentAthleteSessionList] = useState([]);
  const [currentAthleteSessionIndex, setCurrentAthleteSessionIndex] = useState(0);
  const [inputValuesObject, setInputValuesObject] = useState(BLANKEVAL);

  // group analysis
  const [groupAnalysisObject, setGroupAnalysisObject] = useState({});

  // modes
  const [captureModeIsActive, setCaptureModeIsActive] = useState(true);
  const [groupAnalysisMode, setGroupAnalysisMode] = useState(false);
  const [savingEvalMode, setSavingEvalMode] = useState(false);
  const [editingEvalModeIsActive, setEditingEvalModeIsActive] = useState(false);
  const [evalInputModeActive, setEvalInputModeActive] = useState(true);

  const [activeStep, setActiveStep] = useState(0);
  const [activeTest, setActiveTest] = useState(0);
  
  const flask_post = useCallback(async (functionName, inputArray) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}api/flask`, { functionName: functionName, inputArray: inputArray });
        return response;
      } 
      catch (error) {
        console.error('Error in flask_post:', error);
        Swal.fire('Error', functionName + ' failed', 'error');
      } 
    }, []);

  const loadCoaches = useCallback(async () => {
      try {
          const response = await flask_post('GetCoaches', []);
          const responseDataArray = Object.keys(response.data).map((k) => response.data[k]);
          setCoachObjectList(responseDataArray);
      } catch (error) {
          console.error('Error loading coaches:', error);
          Swal.fire('Error', 'Failed to load coaches', 'error');
      }
  }, [flask_post, setCoachObjectList]);
  
  const cloneEvalObject = useCallback((evalObject) => {
    try {
      return structuredClone(evalObject);
    } catch (error) {
      // Fallback for environments without structuredClone
      const cloned = JSON.parse(JSON.stringify(evalObject));
      if (cloned?.measurementDate) cloned.measurementDate = new Date(cloned.measurementDate);
      return cloned;
    }
  }, []);

  const stripOutTests = useCallback((baseEval = BLANKEVAL) => {    
    const blankEval = cloneEvalObject(baseEval);

    const program = athlete?.program;
    if (!program) return blankEval;

    const inputGroupingsObject = getInputGroupings('Gold', program);
    if (!inputGroupingsObject) return blankEval;

    const allowedTags = new Set();
    inputGroupingsObject.forEach(group => {
      (group?.inputTags ?? []).forEach(tag => allowedTags.add(tag));
    });

    Object.keys(blankEval).forEach(test => {
      const looksLikeTestObject = blankEval[test] && typeof blankEval[test] === 'object' && Object.prototype.hasOwnProperty.call(blankEval[test], 'isValid');
      const isNoteField = test.startsWith('notes_');
      if (looksLikeTestObject && !isNoteField && !allowedTags.has(test)) {
        delete blankEval[test];
      }
    });

    if (!blankEval.measurementDate) {
      blankEval.measurementDate = new Date();
    } else if (!(blankEval.measurementDate instanceof Date)) {
      blankEval.measurementDate = new Date(blankEval.measurementDate);
    }

    return blankEval;
  }, [athlete, cloneEvalObject]);
      
  const normalizeEvaluationForProgram = useCallback((evaluation = {}) => {
    const safeEvaluation = cloneEvalObject(evaluation);
    const template = stripOutTests(BLANKEVAL);
    return { ...template, ...safeEvaluation };
  }, [cloneEvalObject, stripOutTests]);
      
  const loadInputValuesObject = useCallback(async (newCaptureMode, newAthleteEvaluations, newAthleteSessionIndex) => {
    const hasEvaluation = Array.isArray(newAthleteEvaluations) && newAthleteEvaluations.length > 0 && newAthleteSessionIndex < newAthleteEvaluations.length;

    if (!newCaptureMode && hasEvaluation) {
      setInputValuesObject(normalizeEvaluationForProgram(newAthleteEvaluations[newAthleteSessionIndex]));
    } else {
      setInputValuesObject(stripOutTests(BLANKEVAL));
    }
  }, [normalizeEvaluationForProgram, stripOutTests, setInputValuesObject]);
  
    const loadAthleteEvaluations = useCallback(async (newAthlete, dataType, explicitCaptureMode = null) => {
      try {
        const response = await flask_post('LoadAthleteEvaluations', [newAthlete, dataType]);
      
        let evaluations_sorted = response.data.slice().sort((a, b) => new Date(b.measurementDate) - new Date(a.measurementDate));
  
        setCurrentAthleteEvaluations(evaluations_sorted);
  
        const sessionList = evaluations_sorted.map(evaluation => 
          `${evaluation.dataType} • ${new Date(evaluation.measurementDate).toLocaleDateString()} (${new Date(evaluation.measurementDate).toLocaleTimeString()})`
        );
        setCurrentAthleteSessionList(sessionList);
        setCurrentAthleteSessionIndex(0);
        
        const effectiveCaptureMode = explicitCaptureMode !== null ? explicitCaptureMode : captureModeIsActive;
        loadInputValuesObject(effectiveCaptureMode, evaluations_sorted, 0);
      } catch (error) {
        console.error('Error loading athlete evaluations:', error);
        Swal.fire('Error', 'Failed to load athlete evaluations', 'error');
      }
    }, [captureModeIsActive, loadInputValuesObject, setCurrentAthleteEvaluations, setCurrentAthleteSessionList, setCurrentAthleteSessionIndex, flask_post]);
  
    const updateAthleteList = useCallback(async (campus, program, gender, evalCount, datatype, currentAthlete) => {
      try {
        const response = await flask_post('LoadAthleteList', [campus, program, gender, evalCount, datatype]);      
        const newList = response.data.sort();
        setAthleteNamesList(newList);
  
        const athletePersists = currentAthlete ? newList.includes(currentAthlete.name) : false;
  
        if (!athletePersists) {
          setAthlete(null);
          setCurrentAthleteEvaluations([]);
          setCurrentAthleteSessionList([]);
          setInputValuesObject(stripOutTests(BLANKEVAL));
        } else {
          const response = await flask_post('LoadAthlete', [currentAthlete.name]);
          const newAthlete = response.data;
          setAthlete(newAthlete);
          loadAthleteEvaluations(newAthlete, datatype);
        }
      } catch (error) {
        console.error('Error loading athlete list:', error);
      }
    }, [setAthlete, loadAthleteEvaluations, setAthleteNamesList, setInputValuesObject, setCurrentAthleteEvaluations, setCurrentAthleteSessionList, stripOutTests, flask_post]);
    
  const createEvaluation = useCallback(async (evaluationInputDataObject, currentAthlete) => {
    setSavingEvalMode(true);
    try {
      const response = await flask_post('CreateEvaluation', [evaluationInputDataObject, currentAthlete, user]);

      if (response.data) {
        Swal.fire('Success', 'Evaluation created successfully', 'success');
        setGroupAnalysisObject({});
        setCaptureModeIsActive(false);
        await loadAthleteEvaluations(currentAthlete, currentDataType, false);
      }
    } catch (error) {
      console.error('Error creating evaluation:', error);
      Swal.fire('Error', 'Failed to create evaluation', 'error');
    } finally {
      setSavingEvalMode(false);
    }
  }, [user, currentDataType, loadAthleteEvaluations, setSavingEvalMode, flask_post, setCaptureModeIsActive, setGroupAnalysisObject]);
    
    const editEvaluation = useCallback(async (evaluationInputDataObject, currentAthlete) => {
      setSavingEvalMode(true);
      try {
        const response = await flask_post('EditEvaluation', [evaluationInputDataObject, currentAthlete, user]);

        if (response.data) {
          Swal.fire('Success', 'Evaluation edited successfully', 'success');
          loadAthleteEvaluations(currentAthlete, currentDataType); // reload and resort the evaluations
          setGroupAnalysisObject({}); // empty the cache to trigger a fresh fetch next time
        }
      } catch (error) {
        console.error('Error editing evaluation:', error);
        Swal.fire('Error', 'Failed to edit evaluation', 'error');
      } finally {
        setSavingEvalMode(false);
        setCaptureModeIsActive(false); 
      }
    }, [user, currentDataType, setSavingEvalMode, setCaptureModeIsActive, loadAthleteEvaluations, flask_post, setGroupAnalysisObject]);
  
  const value = {
    user,
    setUser,
    view,
    setView,
    norms,
    setNorms,
    athlete,
    setAthlete,
    session,
    setSession,
    inputValuesObject,
    setInputValuesObject,
    groupAnalysisObject, 
    setGroupAnalysisObject,

    startDate,
    setStartDate,
    currentCampus,
    setCurrentCampus,
    currentProgram,
    setCurrentProgram,
    currentGender,
    setCurrentGender,
    currentEvalCount,
    setCurrentEvalCount,
    currentDataType, 
    setCurrentDataType,

    campusList,
    setCampusList,
    coachObjectList,
    setCoachObjectList,
    athleteNamesList,
    setAthleteNamesList,
    currentAthleteEvaluations,
    setCurrentAthleteEvaluations,
    currentAthleteSessionList,
    setCurrentAthleteSessionList,
    currentAthleteSessionIndex,
    setCurrentAthleteSessionIndex,
    activeStep,
    setActiveStep,
    activeTest, 
    setActiveTest,

    groupAnalysisMode,
    setGroupAnalysisMode,
    captureModeIsActive, 
    setCaptureModeIsActive,
    editingEvalModeIsActive, 
    setEditingEvalModeIsActive,
    savingEvalMode,
    setSavingEvalMode,
    evalInputModeActive, 
    setEvalInputModeActive,

    // normsObject,
    // setNormsObject,
    // currentAthlete,
    // setCurrentAthlete,
    // captureModeIsActive,
    // setCaptureModeIsActive,
    // editingEvalModeIsActive,
    // setEditingEvalModeIsActive,
    // groupAnalysisObject,
    // setGroupAnalysisObject,
    // generateReportMode,
    // setGenerateReportMode,
    // savingEvalMode,
    // setSavingEvalMode,
    // activeAnalysisTabIndex,
    // setActiveAnalysisTabIndex,
    // analysisTabObject,
    // setAnalysisTabObject,
    // groupAnalysisObject,
    // setGroupAnalysisObject,
    // editingEvalModeIsActive,
    // setEditingEvalModeIsActive,
    // generateReportMode,
    // setGenerateReportMode,
    
    CAMPUSES,
    PROGRAMS,
    PROGRAM_TIERS,
    PROGRAM_GROUPINGS,
    INPUT_SETTINGS,
    BLANKEVAL,

    flask_post,
    updateAthleteList,
    loadAthleteEvaluations,
    loadInputValuesObject,
    createEvaluation,
    editEvaluation,
    stripOutTests,
    loadCoaches
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};